/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'message-items';
const componentName = 'vnic';
const prefix = `${moduleName}.${componentName}`;

export const dataNetworksModalBreadcrumbTitle = `${prefix}.dataNetworksModalBreadcrumbTitle`;
export const managementNetworksModalBreadcrumbTitle = `${prefix}.managementNetworksModalBreadcrumbTitle`;

export const ENGLISH = {
    [dataNetworksModalBreadcrumbTitle]: 'Data Network',
    [managementNetworksModalBreadcrumbTitle]: 'Management Network',
};
